
  <ng-container>
    <div fxLayout="row" fxLayoutAlign="center center">
      <div fxFlex="40" class="logo-container">
        <img [src]="logo" class="company-logo">
      </div>
      <div fxFlex="60">
        <form [formGroup]="azureForm" class="media-wrap">
          <div class="marginDiv" fxLayout="column wrap" fxLayoutGap="10px">
            <mat-form-field appearance="outline" fxFlex="80">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" readonly cdkFocusInitial/>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="80" *ngIf="data?.isIndia">
              <mat-label>PAN</mat-label>
              <input matInput formControlName="panCode" maxlength="10" (input)="azureForm.get('panCode')?.markAsTouched()"/>
              <mat-error *ngIf="azureForm.get('panCode')?.hasError('required') && azureForm.get('panCode')?.touched">
                PAN number is required
              </mat-error>
              <mat-error *ngIf="azureForm.get('panCode')?.hasError('pattern') && azureForm.get('panCode')?.invalid">
                Invalid PAN format
              </mat-error>            </mat-form-field>
          </div>
        </form>
        <div class="button-body" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
          <button *ngIf="azureForm.valid && data?.isIndia" mat-raised-button class="btn-style" matTooltip="Add" (click)="checkPan()">
            <span>Verify</span>
          </button>
          <button *ngIf="!data?.isIndia" mat-raised-button class="btn-style" matTooltip="Login" (click)="onLoginClick()">
            <span>Login</span>
          </button>
          <button mat-raised-button class="btn-style" matTooltip="logout" (click)="logout()">
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>

  </ng-container>
